import Mock from "../mock";

// const JWT_SECRET = 'jwt_secret_key';
// const JWT_VALIDITY = '7 days';

const userList = [
  {
    UserID: 1,
    role: "ADMIN",
    name: "Safin",
    username: "safin2001",
    email: "safin@gmail.com",
    avatar: "/assets/images/user.jpg",
    company:"Plymouth",
    bio: "Enthusiastic software developer with a passion for building intuitive user interfaces.",
  dateofbirth: "1998-06-15", // Example date
  location: "Chennai, India",
  height: "175 cm",
  weight: "70 kg",
  age: 27,
  education: {
    degree: "B.Tech",
    field: "Computer Science",
    university: "Anna University",
    graduationYear: 2020
  },
  languages: ["Tamil", "English", "Hindi", "Telugu", "Kannada"]
  },
  {
    id: 2,
    role: "USER",
    name: "Ram",
    username: "Ram2001",
    email: "ram@gmail.com",
    avatar: "/assets/images/user2.JPEG",
    company:"Plymouth",
    bio: "Enthusiastic software developer with a passion for building intuitive user interfaces.",
  dateofbirth: "1998-06-15", // Example date
  location: "Chennai, India",
  height: "175 cm",
  weight: "70 kg",
  age: 27,
  education: {
    degree: "B.Tech",
    field: "Computer Science",
    university: "Anna University",
    graduationYear: 2020,
    
  },
   languages: ["Tamil", "English", "Hindi", "Telugu", "Kannada"]
  },
  {
    id: 3,
    role: "ADMIN",
    name: "Neelakrishnan",
    username: "nk01",
    email: "neel@gmail.com",
    avatar: "/assets/images/user3.jpg",
    company:"Nicky",
    bio: "Enthusiastic software developer with a passion for building intuitive user interfaces.",
  dateofbirth: "1998-06-15", // Example date
  location: "Chennai, India",
  height: "175 cm",
  weight: "70 kg",
  age: 27,
  education: {
    degree: "B.Tech",
    field: "Computer Science",
    university: "Anna University",
    graduationYear: 2020
  },
   languages: ["Tamil", "English", "Hindi", "Telugu", "Kannada"]
  },
 {
  id: 4,
  role: "USER",
  name: "Shyam",
  username: "shyam01",
  email: "shyam@gmail.com",
  avatar: "/assets/images/user4.jpg",
  company: "S & J",
  bio: "Enthusiastic software developer with a passion for building intuitive user interfaces.",
  dateofbirth: "1998-06-15", // Example date
  location: "Chennai, India",
  height: "175 cm",
  weight: "70 kg",
  age: 27,
  education: {
    degree: "B.Tech",
    field: "Computer Science",
    university: "Anna University",
    graduationYear: 2020
  },
   languages: ["Tamil", "English", "Hindi", "Telugu", "Kannada"]
}
];


Mock.onPost("/api/Login/Login").reply((config) => {
  try {
    const { LoginID, Password } = JSON.parse(config.data);

    const user = userList.find(
      (u) => u.email === LoginID && u.password === Password
    );

    if (!user) {
      return [200, { Status: "N", Message: "Invalid email or password" }];
    }

    return [
      200,
      {
        Status: "Y",
        Message: "Login successful",
        UserDetails: user,
      },
    ];
  } catch (err) {
    console.error(err);
    return [500, { Status: "N", Message: "Internal server error" }];
  }
});



// Mock.onPost("/api/auth/login").reply(async (config) => {
//   try {
//     const { email } = JSON.parse(config.data);
//     const user = userList.find((u) => u.email === email);

//     if (!user) return [400, { message: "Invalid email or password" }];

//     const payload = { user: user};
//     return [200, payload];
//   } catch (err) {
//     console.error(err);
//     return [500, { message: "Internal server error" }];
//   }
// });

Mock.onPost("/api/auth/register").reply((config) => {
  try {
    const { email, username } = JSON.parse(config.data);
    const user = userList.find((u) => u.email === email);

    if (user) return [400, { message: "User already exists!" }];

    const newUser = {
      id: 2,
      role: "GUEST",
      name: "Unknown",
      age: 25,
      email: email,
      username: username,
      avatar: "/assets/images/face-6.jpg"
    };

    userList.push(newUser);

    const payload = { user: { ...newUser } };
    return [200, payload];
  } catch (err) {
    console.error(err);
    return [500, { message: "Internal server error" }];
  }
});

Mock.onGet("/api/auth/profile").reply((config) => {
  try {
    const { Authorization } = config.headers;
    if (!Authorization) {
      return [401, { message: "Invalid Authorization token" }];
    }

    const payload = { user: userList[0] };
    return [200, payload];
  } catch (err) {
    console.error(err);
    return [500, { message: "Internal server error" }];
  }
});
